import { extendTailwindMerge } from 'tailwind-merge';

// Register ZenOpus' custom `zen-*` design-token colors (defined in
// app/globals.css as `--color-zen-*` under the Tailwind 4 `@theme` block).
// Without this extension, classes like `text-zen-surface` are not recognized
// as conflicting with `text-zen-text`, so tailwind-merge would emit both and
// CSS declaration order would decide — producing hard-to-debug low-contrast
// buttons when authoring code tries to override a variant's text color.
// Keep in sync with `--color-zen-*` additions in globals.css.
const ZEN_COLORS = [
  'zen-surface',
  'zen-surface-overlay',
  'zen-surface-muted',
  'zen-surface-strong',
  'zen-text',
  'zen-text-muted',
  'zen-text-subtle',
  'zen-primary',
  'zen-primary-soft',
  'zen-primary-foreground',
  'zen-muted',
  'zen-border',
  'zen-border-strong',
  'zen-border-overlay',
  'zen-ring',
  'zen-danger',
  'zen-danger-soft',
  'zen-info',
  'zen-info-soft',
  'zen-success',
  'zen-success-soft',
  'zen-warning',
  'zen-warning-soft',
];

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: ZEN_COLORS,
    },
  },
});

export function cn(...inputs: Array<string | false | null | undefined>): string {
  return twMerge(inputs.filter(Boolean).join(' '));
}
